import React from 'react';
import SummaryItem from '../shared/summaryitem';
import Spinner from '../shared/spinner';
import dayjs from 'dayjs';
import { ISOCurrencyCovert } from '../../helpers/locationHelper';
import { checkLockout } from '../../helpers/utils';
import { LOCKOUT_MESSAGES } from '../../config';
import { cityList } from '../../helpers/cyoaHelper';
import { calculateGrandTotal } from '../../helpers/priceHelper';
import _map from 'lodash/map';
import _sortBy from 'lodash/sortBy';

const PaymentSummary = (props) => {

  const { product, bookingGroup, bookingGroup:{ group_booking_id, trips, passengers, cyoa_token }, itineraries, itineraries:{ accomm_total } } = props;
  const _product = (product !== undefined) ? product : "";
  const _bookingRef = (group_booking_id !== undefined) ? group_booking_id : "";
  const _expiryTime = (trips !== undefined && trips.length > 0 && trips[0].passengers[0].expiry_time !== null ) ? dayjs(trips[0].passengers[0].expiry_time.split(" ")[0]).format("Do MMMM YYYY") : "";
  const _clients = (passengers !== undefined) ? passengers : "";
  const _lockoutTitle = checkLockout(bookingGroup) ? "Review Your Booking Request" : "Review your booking";
  const _lockoutMessage = checkLockout(bookingGroup) ? <span className="lockout-message" dangerouslySetInnerHTML={{ __html:LOCKOUT_MESSAGES['bookingSummaryMeta'] }}></span>  : ''
  const _currency = (trips !== undefined && trips.length > 0) ? ISOCurrencyCovert(trips[0].iso_currency_code) : '';
  const _stops = (trips !== undefined && trips.length > 0) ? cityList(trips) : "";
  const _grandTotal = (trips !== undefined && trips.length > 0 ) ? calculateGrandTotal(trips, itineraries) : "";
  const _cyoaToken = (cyoa_token !== undefined) ? cyoa_token : "";
  const _hasAccomodation = (itineraries !== undefined) ? accomm_total : "";
  const _accomodationLockoutMessage = (_hasAccomodation !== undefined && accomm_total !== "0.00") ? <span className="lockout-message" dangerouslySetInnerHTML={{ __html:LOCKOUT_MESSAGES['bookingSummaryMetaCyoa'] }}></span> : "";

  return (
    <div className="payment-summary">
      <div className="row">
        <div className="column small-12">
          <h4 className="busabout-h4 no-margin">{_lockoutTitle}</h4>
          <p className="meta-text">Booking Quote Ref: {_bookingRef} <br className="show-for-small-only" /><span className="hide-for-small-only"> |</span> Expiry Date: {_expiryTime} 
            <br /> {_lockoutMessage} {_accomodationLockoutMessage}
          </p>
        </div>
        <div className="column small-12">
          {
            (trips !== undefined && _product.length !== 0) ?
            _map(_sortBy(trips, ['departure_date']), (item, i) => { return <SummaryItem key={i} id={item.booking_identifier} data={item} index={i} currency={_currency} product={_product} clients={_clients} editlink={true} stops={_stops} cyoaToken={_cyoaToken} /> }) :
            <Spinner text="Loading Booking Summary..." loadClass="loading-spinner" />
          }
           <div className="summary-total" style={{display: trips === undefined ? 'none' : 'block'}}>
           <div className="row">
              <div className="column small-12 medium-7">
                <p className="regular">Total include pre-payable taxes</p>
              </div>
              <div className="column small-12 medium-5">
                <p className="bold text-align-right">{_currency}{_grandTotal}</p>
                <p className="text-align-right small-text" style={{display:(_hasAccomodation === undefined || _hasAccomodation === "0.00") ? 'none' : 'block'}}>Accommodation subject to availability to be confirmed via email<sup>*</sup></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default PaymentSummary



// WEBPACK FOOTER //
// ./src/components/payment/paymentsummary.js